import { render, staticRenderFns } from "./main-partners.vue?vue&type=template&id=48a0165b&scoped=true&"
import script from "./main-partners.vue?vue&type=script&lang=js&"
export * from "./main-partners.vue?vue&type=script&lang=js&"
import style0 from "./main-partners.vue?vue&type=style&index=0&id=48a0165b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a0165b",
  null
  
)

export default component.exports